if (process.env.NODE_ENV === "production") {
  console.log("Offline plugin");
  const OfflinePluginRuntime = require("offline-plugin/runtime");
  OfflinePluginRuntime.install({
    onUpdateReady: () => OfflinePluginRuntime.applyUpdate(),
    onUpdated: () => (window.swUpdate = true)
  });
}
